<template>
  <div>
    <div
      class="btn-group"
      data-toggle="buttons"
    >
      <label
        v-for="option in options"
        :key="option.name"
        class="btn btn-primary"
        :disabled="disabled"
        :class="{ active: option == currentActiveOption }"
      >
        <input
          ref="option.name"
          :disabled="disabled"
          class="btn btn-primary"
          :class="{'disabled': disabled}"
          type="radio"
          autocomplete="off"
          checked
          @click="setToggle(option)"
        >
        {{ option.name }}
      </label>
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'MultipleToggle',
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default() {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return [{
          name: 'Off',
          value: 'Off',
        }];
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    defaultValue: {
      type: [Boolean, String, Number],
      default() {
        return null;
      }
    }
  },
  data() { 
    return{
      currentActiveOption: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.currentActiveOption = this.options.find(op => op.value === newValue);
        }
      }
    }
  },
  mounted() {
    if (!this.value && this.defaultValue) {
      this.setToggle(this.options.find(op => op.value === this.defaultValue));
    }
  },
  methods: {
    setToggle(newActiveOption) {
      this.currentActiveOption = newActiveOption;

      this.$emit('onToggle', newActiveOption);
      this.$emit('change', newActiveOption);
    }
  }
};
</script>